var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ol',{staticClass:"breadcrumb"},_vm._l((_vm.categories),function(item){return _c('li',{key:item.id,staticClass:"breadcrumb-item"},[_c('router-link',{attrs:{"to":{ name: 'Category', params: { categoryId: item.id }}}},[_vm._v(" "+_vm._s(item.id === 1 ? "All Categories" : item.name))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }